import React from 'react';
import { Button } from './ui/Button';
import { useLanguage } from '../contexts/LanguageContext';
export function HeroSection() {
  const {
    t
  } = useLanguage();
  return <section id="hero" className="relative min-h-screen w-full flex flex-col pt-24 lg:pt-0 lg:justify-center overflow-hidden bg-[#FAFAF8]" data-id="element-146">
      {/* Decorative Elements */}
      <div className="hidden lg:block absolute left-10 top-1/2 -translate-y-1/2 z-10" data-id="element-147">
        <span className="block vertical-text-left text-[9px] tracking-[0.35em] uppercase opacity-20 font-light" data-id="element-148">
          {t('hero.vertical.left')}
        </span>
      </div>

      <div className="hidden lg:block absolute right-10 top-1/2 -translate-y-1/2 z-10" data-id="element-149">
        <span className="block vertical-text-right text-[9px] tracking-[0.35em] uppercase opacity-20 font-light" data-id="element-150">
          {t('hero.vertical.right')}
        </span>
      </div>

      <div className="max-w-[1600px] w-full mx-auto px-6 md:px-16 lg:px-24 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-center h-full" data-id="element-151">
        {/* Left Content */}
        <div className="lg:col-span-7 flex flex-col justify-center pt-8 lg:pt-0 z-20 order-1" data-id="element-152">
          <div className="mb-6" data-id="element-153">
            <span className="text-[10px] tracking-[0.3em] uppercase text-[#B8956C] font-light" data-id="element-154">
              Premium Atelier
            </span>
          </div>

          {/* Mobile: Title first */}
          <h1 className="font-serif text-5xl md:text-7xl lg:text-9xl leading-[0.95] text-[#1A1A1A] mb-4 lg:mb-6 tracking-tight font-light" data-id="element-155">
            {t('hero.title')}
          </h1>

          {/* Mobile: Subtitle second */}
          <p className="font-serif italic text-2xl md:text-4xl lg:text-6xl text-[#1A1A1A]/60 mb-8 lg:mb-16 font-light" data-id="element-156">
            {t('hero.subtitle')}
          </p>

          {/* Mobile: Image third (only on mobile) */}
          <div className="lg:hidden relative h-[50vh] w-full mb-8 order-2" data-id="element-157">
            <div className="relative h-full w-full overflow-hidden" data-id="element-158">
              <img src="https://cdn.magicpatterns.com/uploads/9hjWk7VhczPtoh6UwJgtR3/IMG_3633.png" alt="Atelier Studio" className="w-full h-full object-cover" data-id="element-159" />
              <div className="absolute inset-0 border border-[#B8956C]/20 pointer-events-none" data-id="element-160"></div>
            </div>
          </div>

          {/* Mobile: Buttons fourth */}
          <div className="flex flex-col sm:flex-row gap-5 order-3" data-id="element-161">
            <Button variant="primary" data-id="element-162">{t('hero.cta1')}</Button>
            <Button variant="outline" data-id="element-163">{t('hero.cta2')}</Button>
          </div>
        </div>

        {/* Right Image - Desktop only */}
        <div className="hidden lg:block lg:col-span-5 relative h-[70vh] w-full order-2" data-id="element-164">
          <div className="relative h-full w-full overflow-hidden" data-id="element-165">
            <img src="https://cdn.magicpatterns.com/uploads/9hjWk7VhczPtoh6UwJgtR3/IMG_3633.png" alt="Atelier Studio" className="w-full h-full object-cover" data-id="element-166" />
            <div className="absolute inset-0 border border-[#B8956C]/20 pointer-events-none" data-id="element-167"></div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="hidden lg:flex absolute bottom-12 left-1/2 -translate-x-1/2 flex-col items-center gap-3 opacity-20" data-id="element-168">
        <div className="h-16 w-[1px] bg-[#1A1A1A]" data-id="element-169"></div>
        <span className="text-[9px] tracking-[0.3em] uppercase font-light" data-id="element-170">
          {t('hero.scroll')}
        </span>
      </div>
    </section>;
}